module.exports = __webpack_public_path__ + "img/apw_next_logo_yoko.f1c10a96.png";